import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  /** Suffix appended to the title's id so multiple instances don't collide. */
  idSuffix?: string;
}

export function SignOutConfirmDialog({
  open,
  onClose,
  onConfirm,
  isPending,
  idSuffix,
}: Props) {
  const titleId = `confirm-signout-title${idSuffix ? `-${idSuffix}` : ''}`;
  return (
    <Dialog
      open={open}
      onClose={() => !isPending && onClose()}
      aria-labelledby={titleId}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id={titleId} sx={{ pb: 1 }}>
        Sign out of Trendz?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          You'll be signed out of this workspace and returned to the login screen.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={isPending}
          autoFocus
        >
          {isPending ? 'Signing out…' : 'Sign out'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
